import { TGetProductListReqDto, TGetProductListResDto } from "@/api/services/admin/product/dtos/get-product-list.dto";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { clientApi } from "@/utils/api";
import { createUrlWithParams } from "@/utils/url";
import { useQuery } from "@tanstack/react-query";

const BASE_URL = "/products";

export const fetchProductListApi = async (req: TGetProductListReqDto): Promise<TGetProductListResDto> => {
  const url = createUrlWithParams(BASE_URL, req);
  const rs = await clientApi.get<TGetProductListResDto>(url);
  return rs.data;
};

export const useProductList = (req: TGetProductListReqDto = {}) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PRODUCT.FETCH_LIST, req],
    queryFn: () => fetchProductListApi(req),
  });
};

export const useProductOptions = (req: TGetProductListReqDto = {}) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PRODUCT.FETCH_LIST, req],
    queryFn: () => fetchProductListApi(req),
    select: (data) =>
      data.data.map((item) => ({
        label: item.name,
        value: item.id,
      })),
  });
};
